<nav class="main-nav" #nav>
  <ol class="nav nav-pills" [ngClass]="{'flex-column': orient === 'vertical'}">
    <ng-content></ng-content>
  </ol>
</nav>
